module.exports = __webpack_public_path__ + "static/media/dots-purple.e7d8519e.png";